import * as React from 'react';
import { SVGProps } from 'react';

const SvgBuy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#buy_svg__a)' fill='#000'>
      <path d='M8.848 20.025a.94.94 0 1 0 0-1.881.94.94 0 0 0 0 1.88ZM17.314 20.025a.94.94 0 1 0 0-1.881.94.94 0 0 0 0 1.88Z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.686 3a.747.747 0 0 1 .477.16c.136.108.23.26.264.428l.517 2.619H20.24a.748.748 0 0 1 .59.268.733.733 0 0 1 .15.629l-1.296 5.771a.735.735 0 0 1-.267.419.747.747 0 0 1-.473.155H7.395l.492 2.377H19.04v1.47H7.28a.747.747 0 0 1-.477-.16.734.734 0 0 1-.264-.427L4.079 4.47H2V3h2.686ZM6.24 7.677l.87 4.301h11.242l.962-4.3H6.24Z'
      />
    </g>
    <defs>
      <clipPath id='buy_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgBuy;
